<template lang="html">
  <b-row align-h="center">
    <b-col lg="6">
      <ExtForm
        :formData="formDataLogin"
        :submitProxy="submitProxyProfile"
        submitBtnText="Сохранить изменения"
        @submitSuccess = "updateLogin"
        scope="login"
        :resetAfterSuccessSubmit="false"
      >
        <b-form-fieldset
          label="Логин"
          :feedback = "errors.first('login')"
          :class="{'is-invalid': errors.has('login') }"
        >
          <input class="form-control" v-validate="'required|eng'" v-model="formDataLogin.login" name="login"/>
        </b-form-fieldset>
      </ExtForm>
      <hr>
      <ExtForm
        :formData="formDataPassword"
        :submitProxy="submitProxyPassword"
        submitBtnText="Изменить пароль"
      >
        <b-form-fieldset
          label="Старый пароль"
          :feedback = "errors.first('oldPassword')"
          :class="{'is-invalid': errors.has('oldPassword') }"
        >
          <input class="form-control" type="password" v-validate="'required'" v-model="formDataPassword.oldPassword" name="oldPassword"/>
        </b-form-fieldset>
        <b-form-fieldset
          label="Новый пароль"
          :feedback = "errors.first('newPassword')"
          :class="{'is-invalid': errors.has('newPassword') }"
        >
          <input class="form-control" type="password" v-validate="'required'" v-model="formDataPassword.newPassword" name="newPassword"/>
        </b-form-fieldset>
        <b-form-fieldset
          label="Пароль повторно"

          :class="{'is-invalid': errors.has('replyPassword') }"
        >
          <input class="form-control" type="password" v-validate="'confirmed:newPassword|required'" v-model="formDataPassword.replyPassword" name="replyPassword"/>
          <div class="form-control-feedback invalid-feedback" v-show="errors.has('replyPassword')">Пароли не совпадают</div>
        </b-form-fieldset>
      </ExtForm>
    </b-col>
  </b-row>
</template>

<script>
import ExtForm from '@/components/ExtForm'

export default {
  name: 'user',
  data () {
    return {
      formDataLogin: {
        login: this.$store.state.auth.user.login
      },
      formDataPassword: {
        oldPassword: '',
        newPassword: ''
      },
      replyPassword: '',
      submitProxyProfile: {
        url: 'api/User/' + this.$store.state.auth.user.id,
        method: 'post'
      },
      submitProxyPassword: {
        url: 'auth/password',
        method: 'post'
      }
    }
  },
  methods: {
    updateLogin () {
      this.$store.dispatch('updateLogin', this.formDataLogin.login)
    }
  },
  components: {
    ExtForm
  }
}
</script>



// WEBPACK FOOTER //
// User.vue?1df1f812